module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_3009.9652f442.png";